import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, DollarSign, Smartphone } from 'lucide-react';
const reasons = [{
  icon: <Clock data-id="element-295" />,
  title: 'Material listo para consultar',
  desc: 'Manuales, videos y diagramas organizados en un solo lugar.'
}, {
  icon: <ShieldCheck data-id="element-296" />,
  title: 'Respaldo técnico',
  desc: 'Contenido claro para trabajar con más seguridad.'
}, {
  icon: <DollarSign data-id="element-297" />,
  title: 'Presupuesta con claridad',
  desc: 'Plantillas para calcular materiales y cotizar mejor.'
}, {
  icon: <Smartphone data-id="element-298" />,
  title: 'Flexibilidad total',
  desc: 'Consulta desde tu celular, tablet o computadora.'
}];
export function WhyChoose() {
  return <section className="py-12 md:py-20 px-4 bg-slate-100 relative border-y border-slate-200" data-id="element-299">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-300">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-navy mb-10 md:mb-16" data-id="element-301">
          ¿Por qué elegir el MEGA KIT?
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-302">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded border border-slate-200 shadow-sm flex flex-col items-center text-center group hover:border-electric transition-all duration-300" data-id="element-303">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-navy rounded flex items-center justify-center mb-6 text-electric group-hover:scale-110 transition-transform duration-300" data-id="element-304">
                {cloneElement(reason.icon as React.ReactElement, {
              size: 36,
              strokeWidth: 2
            })}
              </div>
              <h3 className="text-xl font-black text-navy mb-4 leading-tight" data-id="element-305">
                {reason.title}
              </h3>
              <p className="text-slate-600 text-base font-medium leading-relaxed" data-id="element-306">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}